
/**
 *
 * @param {*} el
 * @param {*} cl
 * @param {*} operation
 */
function applyAnimation(el, cl, operation) {
  if (operation === 'add') {
    el.classList.add(cl);
  }
  if (operation === 'remove') {
    el.classList.remove(cl);
  }
}

const observer = new IntersectionObserver(function(entries, observer) {
  entries.forEach(function(entry) {
    const cl = entry.target.getAttribute('data-io');
    // if (entry.intersectionRatio < 0.25) {
    //   applyAnimation(entry.target, cl, 'add')
    // }

    if (entry.isIntersecting === true) {
      applyAnimation(entry.target, cl, 'remove');
      // stop oberving once animation has ran
      observer.unobserve(entry.target);
    }
  });
}, {rootMargin: '0px 0px -80px 0px', threshold: 0});


/**
 *
 * @param {*} selector
 */
export default function(selector='[data-io]') {
  const targets = document.querySelectorAll(selector);
  targets.forEach(function(item) {
    observer.observe(item);
  });
}
